import React, { Component } from 'react';
import './Button.css';

interface ButtonProps {
  variant?: 'primary' | 'secondary';
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  external?: boolean;
}

class Button extends Component<ButtonProps> {
  handleClick = () => {
    const { onClick } = this.props;
    
    if (onClick) {
      onClick();
    }
  };

  render() {
    const { variant = 'primary', children, className = '', href, external } = this.props;
    const buttonClassName = `btn btn-${variant} ${className}`;

    if (href) {
      return (
        <a
          className={buttonClassName}
          href={href}
          target={external ? '_blank' : undefined}
          rel={external ? 'noopener noreferrer' : undefined}
          onClick={this.handleClick}
        >
          {children}
        </a>
      );
    }
    
    return (
      <button 
        className={buttonClassName}
        onClick={this.handleClick}
      >
        {children}
      </button>
    );
  }
}

export default Button;
